/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AssetHandlerAudioMetadataWaveformOutputDto,
  AwsPresignedUrlDto,
  LyricsVideoExportRequestDto,
  LyricsVideoExportStartedDto,
  TrackAssetCleanCutDetailDto,
  TrackAssetCleanCutUpdateDto,
  TrackAssetLyricsDto,
  TrackAssetLyricsMaskDto,
  TrackAssetLyricsUpdateDto,
  TrackAssetLyricsVideoSceneDto,
  TrackAssetLyricsVideoSceneUpsertDto,
  TrackAssetMinDto,
  TrackAssetPreviewDto,
  TrackAssetPreviewMetadataDto,
  TrackAssetStatusSummaryDto,
  TrackAssetStemDto,
  TrackAssetVideoSummaryDto,
  TrackAssetsControllerGetActiveVideoJobsParams,
  TrackAssetsControllerGetTrackLyricsParams,
  TrackAssetsControllerGetTrackMasteredParams,
  TrackAssetsControllerGetTrackOriginalParams,
  TrackAssetsControllerGetTrackPreviewParams,
  TrackAssetsControllerGetTrackStemsParams,
  TrackAssetsControllerGetTrackWatermarkedParams,
  TrackAssetsControllerGetVideoSummaryParams,
  TrackAssetsControllerTrackAssetPresignedUrlParams,
  TrackAssetsControllerTrackAssetsGetCleancutParams,
  TrackAssetsControllerTrackAssetsGetStatusParams,
  VideoGenerationRequestDto,
  VideoJobResponseDto,
  VideoJobStartResponseDto,
  VideoUpscaleRequestDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Saves the text and queues a forced-alignment pass that re-derives word and segment timestamps from the audio. Until it completes, the previous timestamped lyrics keep being served.
 * @summary Replace the track lyrics with user-corrected text
 */
export const trackAssetsControllerUpdateTrackLyrics = (
  trackId: string,
  trackAssetLyricsUpdateDto: BodyType<TrackAssetLyricsUpdateDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<TrackAssetLyricsUpdateDto>(
    {
      url: `/track-assets/tracks/${trackId}/lyrics`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: trackAssetLyricsUpdateDto,
    },
    options,
  );
};

export const getTrackAssetsControllerUpdateTrackLyricsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyrics>>,
    TError,
    { trackId: string; data: BodyType<TrackAssetLyricsUpdateDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyrics>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetLyricsUpdateDto> },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerUpdateTrackLyrics"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyrics>>,
    { trackId: string; data: BodyType<TrackAssetLyricsUpdateDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return trackAssetsControllerUpdateTrackLyrics(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerUpdateTrackLyricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyrics>>
>;
export type TrackAssetsControllerUpdateTrackLyricsMutationBody =
  BodyType<TrackAssetLyricsUpdateDto>;
export type TrackAssetsControllerUpdateTrackLyricsMutationError =
  ErrorType<unknown>;

/**
 * @summary Replace the track lyrics with user-corrected text
 */
export const useTrackAssetsControllerUpdateTrackLyrics = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyrics>>,
      TError,
      { trackId: string; data: BodyType<TrackAssetLyricsUpdateDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyrics>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetLyricsUpdateDto> },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerUpdateTrackLyricsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * `SUGGESTED` masks only the bad words flagged as maskable, `ALL` masks every bad word on the list, and `extraWords` are masked on top of either, ignoring case and punctuation. The lyrics are masked when they are read, so that part shows up on the next fetch with nothing to re-process. Changing `extraWords` also re-renders the generated clean cut, since the words it silences moved — that runs in the background, and is skipped for a track whose cutlist was placed by hand. The mode alone never re-renders it: a clean cut silences every bad word whatever the mode says.
 * @summary Choose which words the track lyrics are masked against
 */
export const trackAssetsControllerUpdateTrackLyricsMask = (
  trackId: string,
  trackAssetLyricsMaskDto: BodyType<TrackAssetLyricsMaskDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<TrackAssetLyricsMaskDto>(
    {
      url: `/track-assets/tracks/${trackId}/lyrics/mask`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: trackAssetLyricsMaskDto,
    },
    options,
  );
};

export const getTrackAssetsControllerUpdateTrackLyricsMaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyricsMask>>,
    TError,
    { trackId: string; data: BodyType<TrackAssetLyricsMaskDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyricsMask>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetLyricsMaskDto> },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerUpdateTrackLyricsMask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyricsMask>>,
    { trackId: string; data: BodyType<TrackAssetLyricsMaskDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return trackAssetsControllerUpdateTrackLyricsMask(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerUpdateTrackLyricsMaskMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyricsMask>>
  >;
export type TrackAssetsControllerUpdateTrackLyricsMaskMutationBody =
  BodyType<TrackAssetLyricsMaskDto>;
export type TrackAssetsControllerUpdateTrackLyricsMaskMutationError =
  ErrorType<unknown>;

/**
 * @summary Choose which words the track lyrics are masked against
 */
export const useTrackAssetsControllerUpdateTrackLyricsMask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyricsMask>>,
      TError,
      { trackId: string; data: BodyType<TrackAssetLyricsMaskDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerUpdateTrackLyricsMask>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetLyricsMaskDto> },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerUpdateTrackLyricsMaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Discard user-edited lyrics and fall back to the transcription
 */
export const trackAssetsControllerRevertTrackLyrics = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/track-assets/tracks/${trackId}/lyrics/revert`, method: "PUT" },
    options,
  );
};

export const getTrackAssetsControllerRevertTrackLyricsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerRevertTrackLyrics>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerRevertTrackLyrics>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerRevertTrackLyrics"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerRevertTrackLyrics>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return trackAssetsControllerRevertTrackLyrics(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerRevertTrackLyricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerRevertTrackLyrics>>
>;

export type TrackAssetsControllerRevertTrackLyricsMutationError =
  ErrorType<unknown>;

/**
 * @summary Discard user-edited lyrics and fall back to the transcription
 */
export const useTrackAssetsControllerRevertTrackLyrics = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerRevertTrackLyrics>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerRevertTrackLyrics>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerRevertTrackLyricsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const trackAssetsControllerTrackAssetsUpdateCleancut = (
  trackId: string,
  trackAssetCleanCutUpdateDto: BodyType<TrackAssetCleanCutUpdateDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<TrackAssetCleanCutUpdateDto>(
    {
      url: `/track-assets/tracks/${trackId}/cleancut`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: trackAssetCleanCutUpdateDto,
    },
    options,
  );
};

export const getTrackAssetsControllerTrackAssetsUpdateCleancutMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof trackAssetsControllerTrackAssetsUpdateCleancut>
      >,
      TError,
      { trackId: string; data: BodyType<TrackAssetCleanCutUpdateDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdateCleancut>>,
    TError,
    { trackId: string; data: BodyType<TrackAssetCleanCutUpdateDto> },
    TContext
  > => {
    const mutationKey = ["trackAssetsControllerTrackAssetsUpdateCleancut"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof trackAssetsControllerTrackAssetsUpdateCleancut>
      >,
      { trackId: string; data: BodyType<TrackAssetCleanCutUpdateDto> }
    > = (props) => {
      const { trackId, data } = props ?? {};

      return trackAssetsControllerTrackAssetsUpdateCleancut(
        trackId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TrackAssetsControllerTrackAssetsUpdateCleancutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdateCleancut>>
  >;
export type TrackAssetsControllerTrackAssetsUpdateCleancutMutationBody =
  BodyType<TrackAssetCleanCutUpdateDto>;
export type TrackAssetsControllerTrackAssetsUpdateCleancutMutationError =
  ErrorType<unknown>;

export const useTrackAssetsControllerTrackAssetsUpdateCleancut = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof trackAssetsControllerTrackAssetsUpdateCleancut>
      >,
      TError,
      { trackId: string; data: BodyType<TrackAssetCleanCutUpdateDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdateCleancut>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetCleanCutUpdateDto> },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerTrackAssetsUpdateCleancutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const trackAssetsControllerTrackAssetsUpdatePreview = (
  trackId: string,
  trackAssetPreviewMetadataDto: BodyType<TrackAssetPreviewMetadataDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<TrackAssetPreviewMetadataDto>(
    {
      url: `/track-assets/tracks/${trackId}/preview`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: trackAssetPreviewMetadataDto,
    },
    options,
  );
};

export const getTrackAssetsControllerTrackAssetsUpdatePreviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdatePreview>>,
    TError,
    { trackId: string; data: BodyType<TrackAssetPreviewMetadataDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdatePreview>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetPreviewMetadataDto> },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerTrackAssetsUpdatePreview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdatePreview>>,
    { trackId: string; data: BodyType<TrackAssetPreviewMetadataDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return trackAssetsControllerTrackAssetsUpdatePreview(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerTrackAssetsUpdatePreviewMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdatePreview>>
  >;
export type TrackAssetsControllerTrackAssetsUpdatePreviewMutationBody =
  BodyType<TrackAssetPreviewMetadataDto>;
export type TrackAssetsControllerTrackAssetsUpdatePreviewMutationError =
  ErrorType<unknown>;

export const useTrackAssetsControllerTrackAssetsUpdatePreview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdatePreview>>,
      TError,
      { trackId: string; data: BodyType<TrackAssetPreviewMetadataDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsUpdatePreview>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetPreviewMetadataDto> },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerTrackAssetsUpdatePreviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get the saved lyrics video scene for a track
 */
export const trackAssetsControllerGetLyricsVideoScene = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetLyricsVideoSceneDto>(
    {
      url: `/track-assets/tracks/${trackId}/lyrics-video-scene`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getTrackAssetsControllerGetLyricsVideoSceneQueryKey = (
  trackId?: string,
) => {
  return [`/track-assets/tracks/${trackId}/lyrics-video-scene`] as const;
};

export const getTrackAssetsControllerGetLyricsVideoSceneQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetLyricsVideoSceneQueryKey(trackId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>
  > = ({ signal }) =>
    trackAssetsControllerGetLyricsVideoScene(trackId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!trackId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetLyricsVideoSceneQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>
>;
export type TrackAssetsControllerGetLyricsVideoSceneQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerGetLyricsVideoScene<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetLyricsVideoScene<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetLyricsVideoScene<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get the saved lyrics video scene for a track
 */

export function useTrackAssetsControllerGetLyricsVideoScene<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetLyricsVideoScene>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetLyricsVideoSceneQueryOptions(
    trackId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create or replace the lyrics video scene for a track
 */
export const trackAssetsControllerUpsertLyricsVideoScene = (
  trackId: string,
  trackAssetLyricsVideoSceneUpsertDto: BodyType<TrackAssetLyricsVideoSceneUpsertDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<TrackAssetLyricsVideoSceneDto>(
    {
      url: `/track-assets/tracks/${trackId}/lyrics-video-scene`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: trackAssetLyricsVideoSceneUpsertDto,
    },
    options,
  );
};

export const getTrackAssetsControllerUpsertLyricsVideoSceneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerUpsertLyricsVideoScene>>,
    TError,
    { trackId: string; data: BodyType<TrackAssetLyricsVideoSceneUpsertDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerUpsertLyricsVideoScene>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetLyricsVideoSceneUpsertDto> },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerUpsertLyricsVideoScene"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerUpsertLyricsVideoScene>>,
    { trackId: string; data: BodyType<TrackAssetLyricsVideoSceneUpsertDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return trackAssetsControllerUpsertLyricsVideoScene(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerUpsertLyricsVideoSceneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerUpsertLyricsVideoScene>>
  >;
export type TrackAssetsControllerUpsertLyricsVideoSceneMutationBody =
  BodyType<TrackAssetLyricsVideoSceneUpsertDto>;
export type TrackAssetsControllerUpsertLyricsVideoSceneMutationError =
  ErrorType<unknown>;

/**
 * @summary Create or replace the lyrics video scene for a track
 */
export const useTrackAssetsControllerUpsertLyricsVideoScene = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerUpsertLyricsVideoScene>>,
      TError,
      { trackId: string; data: BodyType<TrackAssetLyricsVideoSceneUpsertDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerUpsertLyricsVideoScene>>,
  TError,
  { trackId: string; data: BodyType<TrackAssetLyricsVideoSceneUpsertDto> },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerUpsertLyricsVideoSceneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete the saved lyrics video scene for a track
 */
export const trackAssetsControllerDeleteLyricsVideoScene = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    {
      url: `/track-assets/tracks/${trackId}/lyrics-video-scene`,
      method: "DELETE",
    },
    options,
  );
};

export const getTrackAssetsControllerDeleteLyricsVideoSceneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerDeleteLyricsVideoScene>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerDeleteLyricsVideoScene>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerDeleteLyricsVideoScene"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerDeleteLyricsVideoScene>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return trackAssetsControllerDeleteLyricsVideoScene(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerDeleteLyricsVideoSceneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerDeleteLyricsVideoScene>>
  >;

export type TrackAssetsControllerDeleteLyricsVideoSceneMutationError =
  ErrorType<unknown>;

/**
 * @summary Delete the saved lyrics video scene for a track
 */
export const useTrackAssetsControllerDeleteLyricsVideoScene = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerDeleteLyricsVideoScene>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerDeleteLyricsVideoScene>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerDeleteLyricsVideoSceneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Start rendering the saved lyrics video scene
 */
export const trackAssetsControllerStartLyricsVideoExport = (
  trackId: string,
  lyricsVideoExportRequestDto: BodyType<LyricsVideoExportRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LyricsVideoExportStartedDto>(
    {
      url: `/track-assets/tracks/${trackId}/lyrics-video-export`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lyricsVideoExportRequestDto,
      signal,
    },
    options,
  );
};

export const getTrackAssetsControllerStartLyricsVideoExportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerStartLyricsVideoExport>>,
    TError,
    { trackId: string; data: BodyType<LyricsVideoExportRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerStartLyricsVideoExport>>,
  TError,
  { trackId: string; data: BodyType<LyricsVideoExportRequestDto> },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerStartLyricsVideoExport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerStartLyricsVideoExport>>,
    { trackId: string; data: BodyType<LyricsVideoExportRequestDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return trackAssetsControllerStartLyricsVideoExport(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerStartLyricsVideoExportMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerStartLyricsVideoExport>>
  >;
export type TrackAssetsControllerStartLyricsVideoExportMutationBody =
  BodyType<LyricsVideoExportRequestDto>;
export type TrackAssetsControllerStartLyricsVideoExportMutationError =
  ErrorType<unknown>;

/**
 * @summary Start rendering the saved lyrics video scene
 */
export const useTrackAssetsControllerStartLyricsVideoExport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerStartLyricsVideoExport>>,
      TError,
      { trackId: string; data: BodyType<LyricsVideoExportRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerStartLyricsVideoExport>>,
  TError,
  { trackId: string; data: BodyType<LyricsVideoExportRequestDto> },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerStartLyricsVideoExportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const trackAssetsControllerTrackAssetsRevertCleancut = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/track-assets/tracks/${trackId}/cleancut/revert`, method: "PUT" },
    options,
  );
};

export const getTrackAssetsControllerTrackAssetsRevertCleancutMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof trackAssetsControllerTrackAssetsRevertCleancut>
      >,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsRevertCleancut>>,
    TError,
    { trackId: string },
    TContext
  > => {
    const mutationKey = ["trackAssetsControllerTrackAssetsRevertCleancut"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof trackAssetsControllerTrackAssetsRevertCleancut>
      >,
      { trackId: string }
    > = (props) => {
      const { trackId } = props ?? {};

      return trackAssetsControllerTrackAssetsRevertCleancut(
        trackId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TrackAssetsControllerTrackAssetsRevertCleancutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsRevertCleancut>>
  >;

export type TrackAssetsControllerTrackAssetsRevertCleancutMutationError =
  ErrorType<unknown>;

export const useTrackAssetsControllerTrackAssetsRevertCleancut = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof trackAssetsControllerTrackAssetsRevertCleancut>
      >,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsRevertCleancut>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerTrackAssetsRevertCleancutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit async video generation job from track cover art (early access)
 */
export const trackAssetsControllerGenerateVideo = (
  trackId: string,
  videoGenerationRequestDto: BodyType<VideoGenerationRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<VideoJobStartResponseDto>(
    {
      url: `/track-assets/tracks/${trackId}/generate-video`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: videoGenerationRequestDto,
      signal,
    },
    options,
  );
};

export const getTrackAssetsControllerGenerateVideoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGenerateVideo>>,
    TError,
    { trackId: string; data: BodyType<VideoGenerationRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerGenerateVideo>>,
  TError,
  { trackId: string; data: BodyType<VideoGenerationRequestDto> },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerGenerateVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGenerateVideo>>,
    { trackId: string; data: BodyType<VideoGenerationRequestDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return trackAssetsControllerGenerateVideo(trackId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerGenerateVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGenerateVideo>>
>;
export type TrackAssetsControllerGenerateVideoMutationBody =
  BodyType<VideoGenerationRequestDto>;
export type TrackAssetsControllerGenerateVideoMutationError =
  ErrorType<unknown>;

/**
 * @summary Submit async video generation job from track cover art (early access)
 */
export const useTrackAssetsControllerGenerateVideo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerGenerateVideo>>,
      TError,
      { trackId: string; data: BodyType<VideoGenerationRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerGenerateVideo>>,
  TError,
  { trackId: string; data: BodyType<VideoGenerationRequestDto> },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerGenerateVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit async video upscale job (early access)
 */
export const trackAssetsControllerUpscaleVideo = (
  videoUpscaleRequestDto: BodyType<VideoUpscaleRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<VideoJobStartResponseDto>(
    {
      url: `/track-assets/upscale-video`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: videoUpscaleRequestDto,
      signal,
    },
    options,
  );
};

export const getTrackAssetsControllerUpscaleVideoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerUpscaleVideo>>,
    TError,
    { data: BodyType<VideoUpscaleRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerUpscaleVideo>>,
  TError,
  { data: BodyType<VideoUpscaleRequestDto> },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerUpscaleVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerUpscaleVideo>>,
    { data: BodyType<VideoUpscaleRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return trackAssetsControllerUpscaleVideo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerUpscaleVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerUpscaleVideo>>
>;
export type TrackAssetsControllerUpscaleVideoMutationBody =
  BodyType<VideoUpscaleRequestDto>;
export type TrackAssetsControllerUpscaleVideoMutationError = ErrorType<unknown>;

/**
 * @summary Submit async video upscale job (early access)
 */
export const useTrackAssetsControllerUpscaleVideo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerUpscaleVideo>>,
      TError,
      { data: BodyType<VideoUpscaleRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerUpscaleVideo>>,
  TError,
  { data: BodyType<VideoUpscaleRequestDto> },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerUpscaleVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Poll video job status
 */
export const trackAssetsControllerGetVideoJob = (
  videoJobId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<VideoJobResponseDto>(
    { url: `/track-assets/video-jobs/${videoJobId}`, method: "GET", signal },
    options,
  );
};

export const getTrackAssetsControllerGetVideoJobQueryKey = (
  videoJobId?: string,
) => {
  return [`/track-assets/video-jobs/${videoJobId}`] as const;
};

export const getTrackAssetsControllerGetVideoJobQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
  TError = ErrorType<unknown>,
>(
  videoJobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetVideoJobQueryKey(videoJobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>
  > = ({ signal }) =>
    trackAssetsControllerGetVideoJob(videoJobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!videoJobId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetVideoJobQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>
>;
export type TrackAssetsControllerGetVideoJobQueryError = ErrorType<unknown>;

export function useTrackAssetsControllerGetVideoJob<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
  TError = ErrorType<unknown>,
>(
  videoJobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetVideoJob<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
  TError = ErrorType<unknown>,
>(
  videoJobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetVideoJob<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
  TError = ErrorType<unknown>,
>(
  videoJobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Poll video job status
 */

export function useTrackAssetsControllerGetVideoJob<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
  TError = ErrorType<unknown>,
>(
  videoJobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetVideoJobQueryOptions(
    videoJobId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Cancel a video job
 */
export const trackAssetsControllerCancelVideoJob = (
  videoJobId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/track-assets/video-jobs/${videoJobId}/cancel`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getTrackAssetsControllerCancelVideoJobMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackAssetsControllerCancelVideoJob>>,
    TError,
    { videoJobId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackAssetsControllerCancelVideoJob>>,
  TError,
  { videoJobId: string },
  TContext
> => {
  const mutationKey = ["trackAssetsControllerCancelVideoJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackAssetsControllerCancelVideoJob>>,
    { videoJobId: string }
  > = (props) => {
    const { videoJobId } = props ?? {};

    return trackAssetsControllerCancelVideoJob(videoJobId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackAssetsControllerCancelVideoJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerCancelVideoJob>>
>;

export type TrackAssetsControllerCancelVideoJobMutationError =
  ErrorType<unknown>;

/**
 * @summary Cancel a video job
 */
export const useTrackAssetsControllerCancelVideoJob = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackAssetsControllerCancelVideoJob>>,
      TError,
      { videoJobId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackAssetsControllerCancelVideoJob>>,
  TError,
  { videoJobId: string },
  TContext
> => {
  const mutationOptions =
    getTrackAssetsControllerCancelVideoJobMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get active video jobs for a track (for reattachment)
 */
export const trackAssetsControllerGetActiveVideoJobs = (
  params: TrackAssetsControllerGetActiveVideoJobsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<VideoJobResponseDto[]>(
    { url: `/track-assets/video-jobs`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerGetActiveVideoJobsQueryKey = (
  params?: TrackAssetsControllerGetActiveVideoJobsParams,
) => {
  return [`/track-assets/video-jobs`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerGetActiveVideoJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetActiveVideoJobsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetActiveVideoJobsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>
  > = ({ signal }) =>
    trackAssetsControllerGetActiveVideoJobs(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetActiveVideoJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>
>;
export type TrackAssetsControllerGetActiveVideoJobsQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerGetActiveVideoJobs<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetActiveVideoJobsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetActiveVideoJobs<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetActiveVideoJobsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetActiveVideoJobs<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetActiveVideoJobsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get active video jobs for a track (for reattachment)
 */

export function useTrackAssetsControllerGetActiveVideoJobs<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetActiveVideoJobsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetActiveVideoJobs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetActiveVideoJobsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get persisted video assets for a track
 */
export const trackAssetsControllerGetVideoSummary = (
  params: TrackAssetsControllerGetVideoSummaryParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetVideoSummaryDto>(
    { url: `/track-assets/videos`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerGetVideoSummaryQueryKey = (
  params?: TrackAssetsControllerGetVideoSummaryParams,
) => {
  return [`/track-assets/videos`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerGetVideoSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetVideoSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetVideoSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>
  > = ({ signal }) =>
    trackAssetsControllerGetVideoSummary(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetVideoSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>
>;
export type TrackAssetsControllerGetVideoSummaryQueryError = ErrorType<unknown>;

export function useTrackAssetsControllerGetVideoSummary<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetVideoSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetVideoSummary<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetVideoSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetVideoSummary<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetVideoSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get persisted video assets for a track
 */

export function useTrackAssetsControllerGetVideoSummary<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetVideoSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetVideoSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetVideoSummaryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const trackAssetsControllerTrackAssetPresignedUrl = (
  params: TrackAssetsControllerTrackAssetPresignedUrlParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AwsPresignedUrlDto>(
    { url: `/track-assets/download`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerTrackAssetPresignedUrlQueryKey = (
  params?: TrackAssetsControllerTrackAssetPresignedUrlParams,
) => {
  return [`/track-assets/download`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerTrackAssetPresignedUrlQueryOptions = <
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetPresignedUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerTrackAssetPresignedUrlQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>>
  > = ({ signal }) =>
    trackAssetsControllerTrackAssetPresignedUrl(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerTrackAssetPresignedUrlQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>>
  >;
export type TrackAssetsControllerTrackAssetPresignedUrlQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerTrackAssetPresignedUrl<
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetPresignedUrlParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
          >,
          TError,
          Awaited<
            ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerTrackAssetPresignedUrl<
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetPresignedUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
          >,
          TError,
          Awaited<
            ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerTrackAssetPresignedUrl<
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetPresignedUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTrackAssetsControllerTrackAssetPresignedUrl<
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetPresignedUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetPresignedUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getTrackAssetsControllerTrackAssetPresignedUrlQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const trackAssetsControllerTrackAssetsGetStatus = (
  params: TrackAssetsControllerTrackAssetsGetStatusParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetStatusSummaryDto>(
    { url: `/track-assets/status`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerTrackAssetsGetStatusQueryKey = (
  params?: TrackAssetsControllerTrackAssetsGetStatusParams,
) => {
  return [`/track-assets/status`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerTrackAssetsGetStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerTrackAssetsGetStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>
  > = ({ signal }) =>
    trackAssetsControllerTrackAssetsGetStatus(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerTrackAssetsGetStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>
>;
export type TrackAssetsControllerTrackAssetsGetStatusQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerTrackAssetsGetStatus<
  TData = Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerTrackAssetsGetStatus<
  TData = Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerTrackAssetsGetStatus<
  TData = Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTrackAssetsControllerTrackAssetsGetStatus<
  TData = Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerTrackAssetsGetStatusQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get track stems
 */
export const trackAssetsControllerGetTrackStems = (
  params: TrackAssetsControllerGetTrackStemsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetStemDto[]>(
    { url: `/track-assets/stems`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerGetTrackStemsQueryKey = (
  params?: TrackAssetsControllerGetTrackStemsParams,
) => {
  return [`/track-assets/stems`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerGetTrackStemsQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackStemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetTrackStemsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>
  > = ({ signal }) =>
    trackAssetsControllerGetTrackStems(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetTrackStemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>
>;
export type TrackAssetsControllerGetTrackStemsQueryError = ErrorType<unknown>;

export function useTrackAssetsControllerGetTrackStems<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackStemsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetTrackStems<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackStemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetTrackStems<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackStemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get track stems
 */

export function useTrackAssetsControllerGetTrackStems<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackStemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackStems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetTrackStemsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * By default every word on the bad word list is masked. With `unmasked=true` only the words the list flags as always masked stay hidden. The extra words saved on the track are masked on both reads. Both reads are public.
 * @summary Get lyrics
 */
export const trackAssetsControllerGetTrackLyrics = (
  params: TrackAssetsControllerGetTrackLyricsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetLyricsDto>(
    { url: `/track-assets/lyrics`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerGetTrackLyricsQueryKey = (
  params?: TrackAssetsControllerGetTrackLyricsParams,
) => {
  return [`/track-assets/lyrics`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerGetTrackLyricsQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackLyricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetTrackLyricsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>
  > = ({ signal }) =>
    trackAssetsControllerGetTrackLyrics(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetTrackLyricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>
>;
export type TrackAssetsControllerGetTrackLyricsQueryError = ErrorType<unknown>;

export function useTrackAssetsControllerGetTrackLyrics<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackLyricsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetTrackLyrics<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackLyricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetTrackLyrics<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackLyricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get lyrics
 */

export function useTrackAssetsControllerGetTrackLyrics<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackLyricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackLyrics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetTrackLyricsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get mastered asset
 */
export const trackAssetsControllerGetTrackMastered = (
  params: TrackAssetsControllerGetTrackMasteredParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetMinDto>(
    { url: `/track-assets/mastered`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerGetTrackMasteredQueryKey = (
  params?: TrackAssetsControllerGetTrackMasteredParams,
) => {
  return [`/track-assets/mastered`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerGetTrackMasteredQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackMasteredParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetTrackMasteredQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>
  > = ({ signal }) =>
    trackAssetsControllerGetTrackMastered(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetTrackMasteredQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>
>;
export type TrackAssetsControllerGetTrackMasteredQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerGetTrackMastered<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackMasteredParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetTrackMastered<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackMasteredParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetTrackMastered<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackMasteredParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get mastered asset
 */

export function useTrackAssetsControllerGetTrackMastered<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackMasteredParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackMastered>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetTrackMasteredQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get watermarked asset
 */
export const trackAssetsControllerGetTrackWatermarked = (
  params: TrackAssetsControllerGetTrackWatermarkedParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetMinDto>(
    { url: `/track-assets/watermarked`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerGetTrackWatermarkedQueryKey = (
  params?: TrackAssetsControllerGetTrackWatermarkedParams,
) => {
  return [`/track-assets/watermarked`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerGetTrackWatermarkedQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackWatermarkedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetTrackWatermarkedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>
  > = ({ signal }) =>
    trackAssetsControllerGetTrackWatermarked(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetTrackWatermarkedQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>
>;
export type TrackAssetsControllerGetTrackWatermarkedQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerGetTrackWatermarked<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackWatermarkedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetTrackWatermarked<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackWatermarkedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetTrackWatermarked<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackWatermarkedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get watermarked asset
 */

export function useTrackAssetsControllerGetTrackWatermarked<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackWatermarkedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWatermarked>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetTrackWatermarkedQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get preview asset
 */
export const trackAssetsControllerGetTrackPreview = (
  params: TrackAssetsControllerGetTrackPreviewParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetPreviewDto>(
    { url: `/track-assets/preview`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerGetTrackPreviewQueryKey = (
  params?: TrackAssetsControllerGetTrackPreviewParams,
) => {
  return [`/track-assets/preview`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerGetTrackPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetTrackPreviewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>
  > = ({ signal }) =>
    trackAssetsControllerGetTrackPreview(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetTrackPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>
>;
export type TrackAssetsControllerGetTrackPreviewQueryError = ErrorType<unknown>;

export function useTrackAssetsControllerGetTrackPreview<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackPreviewParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetTrackPreview<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetTrackPreview<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get preview asset
 */

export function useTrackAssetsControllerGetTrackPreview<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackPreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetTrackPreviewQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get original asset
 */
export const trackAssetsControllerGetTrackOriginal = (
  params: TrackAssetsControllerGetTrackOriginalParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetMinDto>(
    { url: `/track-assets/original`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerGetTrackOriginalQueryKey = (
  params?: TrackAssetsControllerGetTrackOriginalParams,
) => {
  return [`/track-assets/original`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerGetTrackOriginalQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackOriginalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetTrackOriginalQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>
  > = ({ signal }) =>
    trackAssetsControllerGetTrackOriginal(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetTrackOriginalQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>
>;
export type TrackAssetsControllerGetTrackOriginalQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerGetTrackOriginal<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackOriginalParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetTrackOriginal<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackOriginalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetTrackOriginal<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackOriginalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get original asset
 */

export function useTrackAssetsControllerGetTrackOriginal<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerGetTrackOriginalParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackOriginal>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetTrackOriginalQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const trackAssetsControllerTrackAssetsGetCleancut = (
  params: TrackAssetsControllerTrackAssetsGetCleancutParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TrackAssetCleanCutDetailDto>(
    { url: `/track-assets/cleancut`, method: "GET", params, signal },
    options,
  );
};

export const getTrackAssetsControllerTrackAssetsGetCleancutQueryKey = (
  params?: TrackAssetsControllerTrackAssetsGetCleancutParams,
) => {
  return [`/track-assets/cleancut`, ...(params ? [params] : [])] as const;
};

export const getTrackAssetsControllerTrackAssetsGetCleancutQueryOptions = <
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetCleancutParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerTrackAssetsGetCleancutQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>>
  > = ({ signal }) =>
    trackAssetsControllerTrackAssetsGetCleancut(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerTrackAssetsGetCleancutQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>>
  >;
export type TrackAssetsControllerTrackAssetsGetCleancutQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerTrackAssetsGetCleancut<
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetCleancutParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
          >,
          TError,
          Awaited<
            ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerTrackAssetsGetCleancut<
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetCleancutParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
          >,
          TError,
          Awaited<
            ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerTrackAssetsGetCleancut<
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetCleancutParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTrackAssetsControllerTrackAssetsGetCleancut<
  TData = Awaited<
    ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>
  >,
  TError = ErrorType<unknown>,
>(
  params: TrackAssetsControllerTrackAssetsGetCleancutParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerTrackAssetsGetCleancut>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getTrackAssetsControllerTrackAssetsGetCleancutQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get waveform data
 */
export const trackAssetsControllerGetWaveformData = (
  trackAssetId: number,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AssetHandlerAudioMetadataWaveformOutputDto>(
    { url: `/track-assets/${trackAssetId}/waveform`, method: "GET", signal },
    options,
  );
};

export const getTrackAssetsControllerGetWaveformDataQueryKey = (
  trackAssetId?: number,
) => {
  return [`/track-assets/${trackAssetId}/waveform`] as const;
};

export const getTrackAssetsControllerGetWaveformDataQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackAssetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetWaveformDataQueryKey(trackAssetId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>
  > = ({ signal }) =>
    trackAssetsControllerGetWaveformData(trackAssetId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!trackAssetId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetWaveformDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>
>;
export type TrackAssetsControllerGetWaveformDataQueryError = ErrorType<unknown>;

export function useTrackAssetsControllerGetWaveformData<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackAssetId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetWaveformData<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackAssetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetWaveformData<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackAssetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get waveform data
 */

export function useTrackAssetsControllerGetWaveformData<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackAssetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetWaveformData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetWaveformDataQueryOptions(
    trackAssetId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get waveform data for the track's original audio, generating it if missing
 */
export const trackAssetsControllerGetTrackWaveformData = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AssetHandlerAudioMetadataWaveformOutputDto>(
    { url: `/track-assets/tracks/${trackId}/waveform`, method: "GET", signal },
    options,
  );
};

export const getTrackAssetsControllerGetTrackWaveformDataQueryKey = (
  trackId?: string,
) => {
  return [`/track-assets/tracks/${trackId}/waveform`] as const;
};

export const getTrackAssetsControllerGetTrackWaveformDataQueryOptions = <
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTrackAssetsControllerGetTrackWaveformDataQueryKey(trackId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>
  > = ({ signal }) =>
    trackAssetsControllerGetTrackWaveformData(trackId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!trackId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackAssetsControllerGetTrackWaveformDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>
>;
export type TrackAssetsControllerGetTrackWaveformDataQueryError =
  ErrorType<unknown>;

export function useTrackAssetsControllerGetTrackWaveformData<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackAssetsControllerGetTrackWaveformData<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
          TError,
          Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackAssetsControllerGetTrackWaveformData<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get waveform data for the track's original audio, generating it if missing
 */

export function useTrackAssetsControllerGetTrackWaveformData<
  TData = Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackAssetsControllerGetTrackWaveformData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackAssetsControllerGetTrackWaveformDataQueryOptions(
    trackId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
